/** @format */

import styled, { css } from 'styled-components';
import config from 'config.json';
import theme from 'theme';
import { InputProps, Status } from './Input.types';

export const InputsGroup = styled.div<{
  justifyContent?: string;
  margin?: string;
}>`
  display: flex;
  margin: 0 5px;
  justify-content: ${(props) => props.justifyContent || 'center'};
  margin: ${(props) => props.margin || '0'};
`;

const setStatusColor = (status: Status) => {
  switch (status) {
    case 'success':
      return theme.successGreen;
    case 'error':
      return theme.errorRed;
    case 'warning':
      return theme.indicatorOrange;
    default:
      return '#d8d8d8';
  }
};

const StyledInput = styled.input<InputProps>`
  && {
    width: 100%;
    line-height: 3rem;
    margin-top: 0.3em;
    margin-bottom: 0.5em;
    padding: 0 1rem;
    background-color: ${theme.lightBackgroundColor};
    border: 1px solid #d8d8d8;
    font-size: 1rem;
    transition: all 0.3s ease-in-out;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    border-radius: 2px;
    display: inline-block;
    box-sizing: border-box;
    height: 3rem;
    font-family:
      Open Sans,
      Asap,
      sans-serif;

    ${config.theme === 'addsecure' &&
    css`
      &&& {
        box-shadow: none;
        border-radius: 5px;
        border-color: #aaa;
        background-color: white;
      }
    `}

    &::placeholder {
      position: relative;
      top: -2px;
      white-space: pre-line;
    }

    &:focus {
      border-color: rgba(82, 168, 236, 0.8);
      outline: none;
      box-shadow:
        inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(82, 168, 236, 0.6);
      ${config.theme === 'addsecure' &&
      css`
        &&& {
          box-shadow: none;
          border-color: mix(white, $ewm-turquoise, 30%);
        }
      `}
    }

    &:read-only {
      -webkit-user-select: all;
      -moz-user-select: all;
      -ms-user-select: all;
      user-select: all;
    }
  }

  ${({ disabled }) =>
    disabled &&
    css`
      &&& {
        background-color: #f5f5f5 !important;
        color: ${theme.grey} !important;
        border: 1px solid ${theme.grey} !important;
        cursor: not-allowed;
      }
    `}

  ${({ readOnly }) =>
    readOnly &&
    css`
      &&& {
        background-color: #f5f5f5 !important;
        color: ${theme.grey} !important;
        border: 1px solid ${theme.grey} !important;
        cursor: not-allowed;
      }
    `}

    ${({ status }) =>
    status &&
    css`
      &&& {
        border: 2px solid ${setStatusColor(status)} !important;
      }
    `}
`;

const Wrapper = styled.div`
  position: relative;
  margin: 0;
`;

const Icon = styled.div`
  position: absolute;
  top: -5px;
  right: -5px;
`;

const Input = (props: InputProps) => {
  return (
    <>
      {props.label ? <label>{props.label}</label> : null}
      <Wrapper>
        <StyledInput
          readOnly={props.readOnly}
          disabled={props.disabled}
          placeholder={props.placeholder}
          type={props.type}
          value={props.value}
          status={props.status}
          onChange={props.onChange}
          name={props.name}
        />
        {props.readOnly || props.disabled ? (
          <Icon>
            <i
              className='fa-solid fa-lock fa-lg'
              style={{ color: theme.darkGrey }}
            ></i>
          </Icon>
        ) : null}
      </Wrapper>
    </>
  );
};

export default Input;
